import * as React from 'react';
import SingleNumberFilterEdit from './SingleNumberFilterEdit';
import { NumberFilterEditProps } from '../providers/SingleValue';

/**
 * Configures a single integer value in a filter
 */
class SingleIntegerFilterEdit extends React.PureComponent<NumberFilterEditProps> {
	constructor(props) {
		super(props);
	}

	public render() {
		return <SingleNumberFilterEdit {...this.props} />;
	}
}

export default SingleIntegerFilterEdit;
